import { notification } from 'antd';

type ToastNotificationType = 'info' | 'success' | 'warning' | 'error';
type ToastNotificationPlacement = 'topLeft' | 'topRight' | 'bottomLeft' | 'bottomRight';

interface ToastNotificationInterface {
    type?: ToastNotificationType;
    message: string;
    description: string;
    placement?: ToastNotificationPlacement;
}

const ToastNotification = (args: ToastNotificationInterface): void => {
    const { type, message, description, placement } = args;
    // notification.destroy();
    notification[type || 'info']({
        message,
        description,
        placement: placement || 'bottomRight',
    });
};

export default ToastNotification;
